export enum Tenant {
  DriverInsights = "",
  Santander = "185",
}
